export default __webpack_public_path__ + "static/media/tcs2.836b556c.jpeg";